<template>
    <div class="menus"
         :style="
            'padding: 0 ' + item.prConfig.val + 'px;' +
            'margin-top:' + item.mbConfig.val +'px;' +
            'color:' + item.titleColor.color[0].item
         "
         :class="[
            {'icon-border-radius': item.menuStyle.type == 1 },
            {'content-border-radius': item.bgStyle.type == 1 },
         ]">
        <div class="menusBox-dan" v-if="item.tabConfig.type == 0" :style="'background-color:' + item.bgColor.color[0].item">
            <div class="menusItem" v-for="(items,index) in item.menuConfig.list" :key="index">
                <img :src="items.img">
                <span>{{items.info[0].value}}</span>
            </div>
        </div>
        <div class="menusBox-duo" v-else :style="'background-color:' + item.bgColor.color[0].item">
            <div class="menusItem" v-for="(items,index) in item.menuConfig.list" :key="index"
                 :style="'width:' + (100 / (item.number.type + 3)) + '%'"
                 v-if="index < (item.number.type + 3) * (item.rowsNum.type + 2)"
            >
                <img :src="items.img">
                <span>{{items.info[0].value}}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return{

        }
    },
    props:{
        item:{
            type:Object,
            default:{}
        }
    },
}
</script>

<style scoped lang="scss">

// 单行
.menusBox-dan{
    width: 100%;
    padding: 0 12px 12px;
    display: flex;
    flex-wrap: nowrap;
    overflow: hidden;
    .menusItem{
        flex-shrink: 0;
        width: 48px;
        height: 70px;
        margin: 12px 28px 0 0;
        font-size: 12px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        img{
            width: 48px;
            height: 48px;
        }
    }
}

// 多行
.menusBox-duo{
    width: 100%;
    padding: 0 12px 12px;
    display: flex;
    flex-wrap: wrap;
    .menusItem{
        width: 20%;
        height: 70px;
        margin-top: 12px;
        font-size: 12px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;

        img{
            width: 50px;
            height: 50px;
        }
    }
}

// 图标
.icon-border-radius{
    img{
        border-radius: 50%;
        overflow: hidden;
    }
}

.content-border-radius{
    >div{
        border-radius: 6px;
    }
}
</style>